import type { IconProps } from './IconProps';

export const XIconGray = (props: IconProps) => (
  <svg
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 34}
    height={props.height ?? 34}
    {...props}
  >
    <g filter="url(#filter0_dii_4628_15192)">
      <rect x="3" y="2" width="28" height="28" rx="14" fill="#F1F2F4" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.773 12.5234C22.131 12.1655 22.131 11.5851 21.773 11.2271C21.415 10.8691 20.8346 10.8691 20.4766 11.2271L17 14.7037L13.5234 11.2271C13.1654 10.8691 12.585 10.8691 12.227 11.2271C11.869 11.5851 11.869 12.1655 12.227 12.5234L15.7036 16L12.227 19.4767C11.869 19.8346 11.869 20.415 12.227 20.773C12.585 21.131 13.1654 21.131 13.5234 20.773L17 17.2964L20.4766 20.773C20.8346 21.131 21.415 21.131 21.773 20.773C22.131 20.415 22.131 19.8346 21.773 19.4767L18.2964 16L21.773 12.5234Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.773 12.5234C22.131 12.1655 22.131 11.5851 21.773 11.2271C21.415 10.8691 20.8346 10.8691 20.4766 11.2271L17 14.7037L13.5234 11.2271C13.1654 10.8691 12.585 10.8691 12.227 11.2271C11.869 11.5851 11.869 12.1655 12.227 12.5234L15.7036 16L12.227 19.4767C11.869 19.8346 11.869 20.415 12.227 20.773C12.585 21.131 13.1654 21.131 13.5234 20.773L17 17.2964L20.4766 20.773C20.8346 21.131 21.415 21.131 21.773 20.773C22.131 20.415 22.131 19.8346 21.773 19.4767L18.2964 16L21.773 12.5234Z"
      fill="url(#paint0_linear_4628_15192)"
    />
    <defs>
      <filter
        id="filter0_dii_4628_15192"
        x="0"
        y="0"
        width="34"
        height="34"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4628_15192" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4628_15192"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_4628_15192" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1"
          operator="erode"
          in="SourceAlpha"
          result="effect3_innerShadow_4628_15192"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_4628_15192"
          result="effect3_innerShadow_4628_15192"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4628_15192"
        x1="23.5628"
        y1="14.2102"
        x2="15.2101"
        y2="22.5629"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3A3841" />
        <stop offset="1" stopColor="#B3B3B3" />
      </linearGradient>
    </defs>
  </svg>
);
